import ChatBot from 'react-simple-chatbot';
import React, { Component, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import './Chat.css';
import protocolImgInd from './protocol-ind.png';
import protocolImgTest from './protocol-test.png';

const link = 'https://forms.gle/AdM2d5Bx5tXeQiHp6';
const careerlink = 'http://career.snu.ac.kr/student/';
const CTLLINK = 'https://ctl.snu.ac.kr/';
const Delay = 0;



const Return = props => {
    if (props.hasOwnProperty("program")){
        return(
        <div>
            <ul className="sc-ifAKCX gkhNlr rsc-os-options">
                <li className="sc-htpNat GgOGn rsc-os-option">
                    <button className="sc-bxivhb iRnUKy rsc-os-option-element" onClick={e => {
                        e.target.parentElement.parentElement.parentElement.style.display="none";
                        props.triggerNextStep({ trigger: props.trigger })
                    }}>다른 프로그램 보기</button>
                </li>
                <li className="sc-htpNat GgOGn rsc-os-option">
                    <button className="sc-bxivhb iRnUKy rsc-os-option-element" onClick={e => {
                        e.target.parentElement.parentElement.parentElement.style.display="none";
                        props.triggerNextStep({ trigger: 'hello-world'});
                    }}>처음으로 돌아가기</button>
                </li>
            </ul>
        </div>)
    }
    else return(
        <div>
            <ul className="sc-ifAKCX gkhNlr rsc-os-options">
                <li className="sc-htpNat GgOGn rsc-os-option">
                    <button className="sc-bxivhb iRnUKy rsc-os-option-element end-bubble" onClick={(e) => {
                    e.target.parentElement.parentElement.parentElement.style.display="none";
                    props.triggerNextStep({ trigger: 'hello-world'});
                    }}>
                    {props.lan === "EN" ? "HOME" : '처음으로 돌아가기'}
                    </button>
                </li>
            </ul>    
        </div>
    )
}
const steps = [
    {
        id: 'hello-world',
        asMessage: true, 
        component: (
            <div>
        <p> 안녕하세요, 교내 상담센터 챗봇 샤샤입니다. 저를 찾아주셔서 감사합니다. </p>
        <p> Hello, I am SHASHA, chatbot at SNU's counseling center. Nice to meet you. </p>
    </div>
        ),
        trigger: 'check-lan'
    },{
        id: 'check-lan', 
        options: [
            { value: 'KO', label: '한국어 (KOR)', trigger: 'check-major-intro'},
            { value: 'EN', label: '영어 (ENG)', trigger: 'deptEN'}
        ]
    },{
        id: 'check-major-intro',
        component: (
            <div>
        <p> 교내 상담센터는 휴학생이나 수료생, 교직원에도 서비스를 제공하고 있습니다.  </p>
        <p> 또한 샤샤는 비밀 보장 원칙이 철저하게 보장되는 챗봇입니다. 편하게 둘러보세요. </p>
        <p className="high-light"> 소속을 선택해 주세요</p>
    </div>  
        ),
        asMessage: true,
        trigger: 'check-major'
    },
    {
        id: 'check-major',
        options: [
            { value: 0, label: '경영대', trigger: 'dept01' },
            { value: 1, label: '공대', trigger: 'dept02' },
            { value: 2, label: '농생대', trigger: 'dept03' },
            { value: 3, label: '법대', trigger: 'dept04' },
            { value: 4, label: '인문대', trigger: 'dept05' },
            { value: 5, label: '사범대', trigger: 'dept06' },
            { value: 6, label: '자연대', trigger: 'dept07' },
            { value: 7, label: '연건캠퍼스', trigger: 'dept08' },
            { value: 8, label: '사회대', trigger: 'dept09' },
            { value: 9, label: '미대', trigger: 'dept10' },
            { value: 10, label: '생활대', trigger: 'dept00'},
            { value: 11, label: '음대', trigger: 'dept00'},
            { value: 12, label: '돌아가기', trigger: 'hello-world'}
        ],
    },
    {
        id: 'end',
        component: <Return lan="KO"/>,
    },
    {
        id: 'end-EN',
        component: <Return lan="EN"/>,
    },
    {
        id: 'career',
        component: (
            <div>
                <p>진로에 대해 고민하고 계신가요? </p>
                <p>경력개발센터에서는 진로 검사, 진로 상담, 진로 설계 집단상담 및 프로그램 등이 마련되어 있습니다. </p>
            </div>
        ),
        asMessage: true,
        trigger: 'career-01'
    },
    {
        id: 'career-01',
        message: '자세한 프로그램 정보와 신청을 원하시면 아래 [경력개발센터 홈페이지] 버튼을 클릭해주세요.',
        trigger: 'career-02'
    },
    {
        id: 'career-02',
        component: (
            <a className='apply-link' target="_blank" href={careerlink}>[경력개발센터 홈페이지]</a>
        ),
        asMessage: true,
        trigger: 'end'
    },{
        id: 'CTL',
        component:(
            <div>
                <p>학습지원이 필요하신가요? </p>
                <p>교수학습개발센터(CTL)에서는 학습상담, 소그룹 학습코칭, 학습유형검사, 역량강화 워크숍, 글쓰기 튜터링 및 클리닉, 온라인 교육 등을 제공하고 있습니다.  </p>
            </div>
        ),
        asMessage: true,
        trigger: 'CTL-01'
    },
    {
        id: 'CTL-01',
        message: '자세한 프로그램 정보와 신청을 원하시면 아래 [CTL 홈페이지] 버튼을 클릭해주세요.',
        trigger: 'CTL-02'
    },
    {
        id: 'CTL-02',
        component: (
            <a className='apply-link' target="_blank" href={CTLLINK}>[CTL 홈페이지]</a>
        ),
        asMessage: true,
        trigger: 'end'

    },
    {
        id: 'SNUCALL',
        message: '그렇군요. 필요한 도움을 드리고 싶습니다. 지금 24시간 위기전화 SNUCALL로 전화해주실 수 있을까요?',
        trigger: 'SNUCALL-01'
    },{
        id: 'SNUCALL-01',
        message: '스누콜은 즉시적인 단회 상담(50분)과 함께 가장 적절한 심리적 서비스를 받을 수 있도록 안내하고 도와드립니다.',
        trigger: 'SNUCALL-CALL'
    },{
        id: 'SNUCALL-CALL',
        component: (<div className="SNUCALL">
            SNU CALL 02 880-8080
        </div>),
        asMessage: true,
        trigger: 'end'
    },{
        id: 'ind-img', 
        component: (
        <div>
            <img className="protocol" src={protocolImgInd}></img>
        </div>),
        trigger: "end"
    },{
        id: 'test-img',
        component: (<div>
            <img  className="protocol" src={protocolImgTest}></img>
        </div>),
        trigger: "end"

    }
]



const deptCenterInfo = {
    '00': {
        center: [],
        list: ['대생원']
    },
    '01': {
        center: [
            { value: 'c01', label: '경영대학 학생상담센터 경청', trigger: 'c01'}
        ],
        list: ['대생원', '경영대학 학생상담센터 경청']
    },
    '02': {
        center: [
            { value: 'c02', label: '공과대학 학생상담센터 공감', trigger: 'c02'}
        ],
        list: ['대생원', '공과대학 학생상담센터 공감']
    },
    '03': {
        center: [
            { value: 'c03', label: '농업생명과학대학 상담실', trigger: 'c03'}
        ],
        list: ['대생원', '농업생명과학대학 상담실']
    },
    
    '04': {
        center: [
            { value: 'c04', label: '법학전문대학원 학생지원센터', trigger: 'c04'}
        ],
        list: ['대생원', '법학전문대학원 학생지원센터']
    },
    '05': {
        center: [
            { value: 'c05', label: '인문대학 학생생활문화원 생생원', trigger: 'c05'}
        ],
        list: ['대생원', '인문대학 학생생활문화원 생생원']
    },
    '06': {
        center: [
            { value: 'c06', label: '사범대학 학생상담센터 사담', trigger: 'c06'}
        ],
        list: ['대생원', '사범대학 학생상담센터 사담']
    },
    '07': {
        center: [
            { value: 'c07', label: '자연대학 학생상담센터 자:우리', trigger: 'c07'}
        ],
        list: ['대생원', '자연대학 학생상담센터 자:우리']
    },
    '08': {
        center: [
            { value: 'c08', label: '연건학생지원센터', trigger: 'c08'}
        ],
        list: ['대생원', '연건학생지원센터']
    },
    '09': {
        center: [
            { value: 'c09', label: '사회랑朗', trigger: 'c09'}
        ],
        list: ['대생원', '사회랑朗']
    },
    '10': {
        center: [
            { value: 'c10', label: '미술대학 상담실 미소', trigger: 'c10'}
        ],
        list: ['대생원', '미술대학 상담실 미소']
    }

}

const testDept = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10'].map(id => {
    let tmp = (['01', '03', '04', '05'].map(obj => {
        return([
            {
                id: `ob${obj}-test-${id}`,
                message: '심리검사 종류는 기본적으로  MBTI, MMPI, CST, STRONG, TCI 등이 있으며, 단과대 센터 별로 차이는 있습니다. 우울하거나 심적으로 힘들다고 느낄 때는 MMPI, TCI를, 자신을 더 깊이있게 이해하고 싶을 때는 MBTI, CST, TCI를, 진로에 대한 고민이 있다면 STRONG, MBTI, CST가 도움이 됩니다.',
                trigger: `ob${obj}-test-${id}-01`
            },{
                id: `ob${obj}-test-${id}-01`,
                message: '검사 신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
                trigger: `ob${obj}-test-${id}-apply`
            },{
                id: `ob${obj}-test-${id}-apply`,
                options: [
                    { value: 'apply', label: '신청하기', trigger: `test-${obj}-${id}-apply-c-select-intro`},
                    { value: 'return', label: '돌아가기', trigger: `ob${obj}-${id}-apply`}
                ]
            },{
                id: `test-${obj}-${id}-apply-c-select-intro`, // 기관선택
                message: '신청하고 싶은 기관을 선택해주세요',
                trigger: `test-${obj}-${id}-apply-c-select`
            },{
                id: `test-${obj}-${id}-apply-c-select`, // 기관선택
                options: (deptCenterInfo[`${id}`].list.map((val, idx) => {
                    return ({
                        value: idx, label: val, trigger: `c${id}-test-apply-link`
                    })
                })).concat([
                    { value: 'dorm', label: '관악학생생활관 학생상담센터 관심', trigger: `DORM-test-ob${obj}-${id}`},
                    { value: 'return', label: '돌아가기', trigger: `ob${obj}-test-${id}-apply`}
                ])
            },{
                id: `DORM-test-ob${obj}-${id}`,
                message: '현재 관악학생생활관에 거주중이신가요?',
                trigger: `if-DORM-test-ob${obj}-${id}`
            },{
                id: `if-DORM-test-ob${obj}-${id}`,
                options: [
                    { value: true, label: '네', trigger: `c${id}-test-apply-link`},
                    { value: false, label: '아니요', trigger: `no-DORM-test-ob${obj}-${id}`},
                    { value: 'return', label: '돌아가기', trigger: `test-${obj}-${id}-apply-c-select-intro`}
                ]
            },{
                id: `no-DORM-test-ob${obj}-${id}`,
                message: '관악학생생활관 학생삼단센터 관심에서는 생활관 사생을 대상으로 상담을 제공하고 있습니다. 상담이 필요한 경우, 소속 단과대 상담센터나 대학생활문화원을 이용해주세요',
                trigger: `test-${obj}-${id}-apply-c-select-intro`
            }
        ])

    })).flat();
    return tmp;
}).flat();

const indDept = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10'].map(id => {
    let tmp = (['01', '03', '04', '05', '06'].map(obj => {
        return([
            {
                id: `ob${obj}-ind-${id}`,
                message: '상담은 현재 당면한 심리적 어려움에 효과적으로 대처할 뿐 아니라, 내면의 잠재력을 발견하면서 성장하는 과정입니다. 상담을 통하여 상담자는 심리적 고통을 유발하는 행동방식, 사고방식, 감정의 문제들을 다루고 삶에 변화가 일어나도록 돕습니다. 상담내용과 사적 정보는 비밀로 유지됩니다. ',
                trigger: `ob${obj}-ind-${id}-01`
            },{
                id: `ob${obj}-ind-${id}-01`,
                message: '신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
                trigger: `ob${obj}-ind-${id}-apply`
            },{
                id: `ob${obj}-ind-${id}-apply`,
                options: [
                    { value: 'apply', label: '신청하기', trigger: `ind-${obj}-${id}-apply-c-select-intro`},
                    { value: 'return', label: '돌아가기', trigger: `ob${obj}-${id}-apply`}
                ]
            },{
                id: `ind-${obj}-${id}-apply-c-select-intro`, // 기관선택
                message: '신청하고 싶은 기관을 선택해주세요',
                trigger: `ind-${obj}-${id}-apply-c-select`
            },{
                id: `ind-${obj}-${id}-apply-c-select`, // 기관선택
                options: (deptCenterInfo[`${id}`].list.map((val, idx) => {
                    return ({
                        value: idx, label: val, trigger: `c${id}-ind-apply-link`
                    })
                })).concat([
                    { value: 'dorm', label: '관악학생생활관 학생상담센터 관심', trigger: `DORM-ind-ob${obj}-${id}`},
                    { value: 'return', label: '돌아가기', trigger: `ob${obj}-ind-${id}-apply`}
                ])
            },{
                id: `DORM-ind-ob${obj}-${id}`,
                message: '현재 관악학생생활관에 거주중이신가요?',
                trigger: `if-DORM-ind-ob${obj}-${id}`
            },{
                id: `if-DORM-ind-ob${obj}-${id}`,
                options: [
                    { value: true, label: '네', trigger: `c${id}-ind-apply-link`},
                    { value: false, label: '아니요', trigger: `no-DORM-ind-ob${obj}-${id}`},
                    { value: 'return', label: '돌아가기', trigger: `ind-${obj}-${id}-apply-c-select-intro`}
                ]
            },{
                id: `no-DORM-ind-ob${obj}-${id}`,
                message: '관악학생생활관 학생삼단센터 관심에서는 생활관 사생을 대상으로 상담을 제공하고 있습니다. 상담이 필요한 경우, 소속 단과대 상담센터나 대학생활문화원을 이용해주세요',
                trigger: `ind-${obj}-${id}-apply-c-select-intro`
            }
        ])

    })).flat();
    return tmp;
}).flat();



const dept = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10'].map(id => {
    return([{
        id: `dept${id}`,
    component: (
        <div>프로그램을 추천 받고 싶다면 <div className="high-light">‘프로그램 추천받기</div>, 
    프로그램 정보를 보고 싶다면 <div className="high-light">'프로그램 목록보기'</div>를 눌러주세요.
    </div>
        ),
        asMessage: true,
        trigger: `dept-option-${id}`
    },{
        id: `dept-option-${id}`,
        options: [
            { value: `rec-${id}`, label: '프로그램 추천받기', trigger: `rec-${id}-intro`},
            { value: `list-${id}`, label: '프로그램 목록보기', trigger: `list-${id}-intro`},
            { value: 'return', label: '돌아가기', trigger: 'check-major-intro'}
        ]
    },{
        id: `rec-${id}-intro`,
        component: (<div>
            <p> 어떤 도움이 필요하세요? </p>
            <p> 나에게 가장 맞는 호소 문제를 선택해 주시면, 관련 프로그램을 추천해 드립니다.</p>
        </div>),
        asMessage: true,
        trigger: `rec-${id}`
    },
    {
        id: `rec-${id}`,
        options: [
            { value: 1, label: '나를 더 잘 이해하고 싶어요', trigger: `ob01-intro-${id}`},
            { value: 2, label: '학업/성적/진로 문제로 힘들어요', trigger: `ob02-intro-${id}`},
            { value: 3, label: '대인관계 문제로 힘들어요', trigger: `ob03-intro-${id}`},
            { value: 4, label: '번-아웃이 온것 같아요', trigger: `ob04-intro-${id}`},
            { value: 6, label: '자살이나 자해 시도, 생각을 해요', trigger: `ob06-intro-${id}`},
            { value: 5, label: '힘든 이유가 분명하지 않아요', trigger: `ob05-intro-${id}`},
            { value: 'return', label: '이전 단계로 돌아가기', trigger: `dept-option-${id}`}
        ]
    },{
        id: `ob01-intro-${id}`,
        component: (
            <div>
                스스로를 더 잘 이해하고 싶군요. <br /> 이런 프로그램은 어떠세요?
            </div>
        ),
        asMessage: true,
        trigger: `ob01-msg-${id}`
    },{
        id: `ob01-msg-${id}`,
        component: (<div>
            <p><div className="high-light">심리 검사</div>는 공인된 심리 검사지를 통해 자신을 객관적으로 이해하는 것을 도와줍니다. 심리 검사에는 검사 실시 및 해석이 포함되며, 모두 비대면으로 실시됩니다.</p>
            <p><div className="high-light">개인상담</div>은 보통 1주일에 1번씩 1:1로 이루어지며, 대면 또는 비대면으로 이루어집니다. 당면한 어려움을 깊이있게 다룰 수 있습니다.</p>
            <p><div className="high-light">대인관계향상을 위한 T-talk 집단상담</div> 프로그램은 학기 중 주 1회 2~3시간씩, 총 10회기, 대면 및 비대면으로 진행됩니다.</p>
        </div>),
        asMessage: true,
        trigger: `ob01-${id}`
    },{
        id: `ob01-${id}`,
        message: '아래 프로그램 이름을 눌러보세요. 더 자세한 설명과 신청 방법이 안내 됩니다.',
        trigger: `ob01-${id}-apply`
    },{
        id: `ob01-${id}-apply`,
        options: [
            { value: 0, label: '심리검사', trigger: `ob01-test-${id}`},
            { value: 1, label: '개인상담', trigger: `ob01-ind-${id}`},
            { value: 2, label: '대인관계향상 집단상담', trigger: `ob01-CCLC-2-${id}`},
            { value: 'return', label: '돌아가기', trigger: `rec-${id}`}
        ]
    },{
        id: `ob01-CCLC-2-${id}`,
        message: '대인관계향상 T-talk 집단상담 프로그램에서는 나 자신, 친구, 가족, 연인 등 주변 사람들과의 관계 속의 내 모습을 돌아보고, 여러 관계 속에서 보여지는 나의 모습과 나만이 아는 진짜 나의 모습의 차이를 이해함으로써 보다 자연스러운 \'자기\'를 찾아가는 경험을 제공합니다.',
        trigger: `ob01-CCLC-2-${id}-1`
    },{
        id: `ob01-CCLC-2-${id}-1`,
        component: (<div>
            <p>대상: 관계를 형성하고 의사소통하는 방식을 이해하고 효과적인 방법을 연습해보고 싶은 학부 및 대학원생</p>
            <p>내용: 대인관계 패턴 파악 및 효과적인 의사소통 방법에 대한 심리교육 및 실습</p>
            <p>진행방식: 학기 중 주 1회 2~3시간씩, 총 10회기, 대면 또는 비대면</p>
        </div>),
        asMessage: true,
        trigger: `ob01-CCLC-2-${id}-2`,
    },{
        id: `ob01-CCLC-2-${id}-2`,
        message: '신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
        trigger: `ob01-CCLC-2-${id}-button`
    },{
        id: `ob01-CCLC-2-${id}-button`,
        options: [
            { value: 'apply', label: '신청하기', trigger: `ob01-CCLC-2-${id}-apply`},
            { value: 'return', label: '돌아가기', trigger: `ob01-${id}-apply`}
        ]
    },{
        id: `ob01-CCLC-2-${id}-apply`,
        component: (<div>
            <p>본 프로그램에 관심을 가져주셔서 감사합니다. 아쉽게도 지금은 신청을 받고 있지않습니다. </p>
            <p>T-talk 프로그램은 매 학기 진행되며, 학기 초(3월, 6월, 9월, 12월)에 모집하고 있습니다.</p>
        </div>),
        asMessage: true,
        trigger: `end-ob01-CCLC-2-${id}-apply`
    },{
        id: `end-ob01-CCLC-2-${id}-apply`,
        component: <Return lan="KO" program ="ob01-CCLC-2" trigger={`ob01-${id}-apply`}/>
    },{
        id: `ind-${id}-apply-c-select-intro`, // 기관선택
        message: '신청하고 싶은 기관을 선택해주세요',
        trigger: `ind-${id}-apply-c-select`
    },{
        id: `ind-${id}-apply-c-select`, // 기관선택
        options: (deptCenterInfo[`${id}`].list.map((val, idx) => {
            return ({
                value: idx, label: val, trigger: `c${id}-ind-apply-link`
            })
        }))
    },{
        id: `test-${id}-apply-c-select-intro`, // 기관선택
        message: '신청하고 싶은 기관을 선택해주세요',
        trigger: `test-${id}-apply-c-select`

    },{
        id: `test-${id}-apply-c-select`, // 기관선택
        options: (deptCenterInfo[`${id}`].list.map((val, idx) => {
            return ({
                value: idx, label: val, trigger: `c${id}-test-apply-link`
            })
        }))
    },{
        id: `ob02-intro-${id}`,
        component: (
            <div>
                학업, 성적, 진로 관련 고민이 있으신가 봐요.
                <br/>이런 프로그램은 어떠세요?
            </div>
        ),
        asMessage: true,
        trigger: `ob02-msg-${id}`
    },{
        id: `ob02-msg-${id}`,
        component: (<div>
            <p><div className="high-light">경력개발센터</div>에서는 진로 검사, 진로 상담, 진로 설계 집단상담 및 진로 설계 프로그램 등 다양한 진로 프로그램이 마련되어 있습니다.</p>
            <p><div className="high-light">교수학습개발센터</div>에서는 학습상담, 소그룹 학습코칭, 학습유형검사, 다양한 주제의 역량강화 워크숍, 글쓰기 튜터링 및 클리닉 프로그램, 온라인 교육 등 다양한 학습지원을 제공하고 있습니다.</p>
            <p><div className="high-light">학업마인드점프</div>는 학관에 모여 식사를 함께하며 학업과 일상생활 관리를 향상할 수 있도록 도와주는 대학생활문화원의 프로그램입니다.</p>
        </div>),
        asMessage: true, 
        trigger: `ob02-${id}`
    },{
        id: `ob02-${id}`,
        message: '아래 프로그램 이름을 눌러보세요. 더 자세한 설명과 신청 방법이 안내 됩니다.',
        trigger: `ob02-${id}-apply`
    },{
        id: `ob02-${id}-apply`,
        options: [
            { value: 's03', label: '경력개발센터', trigger: 'career'},
            { value: 's02', label: '교수학습개발센터', trigger: 'CTL'},
            { value: 0, label: '학업마인드 점프', trigger: `CCLC-4-${id}`},
            { value: 'return', label: '돌아가기', trigger: `rec-${id}`}
        ]
    },{
        id: `CCLC-4-${id}`,
        message: '낮은 학점, 학사경고는 여러분이 대학생활에서 겪을 수 있는 어려움 중 하나입니다. 삶에서 어려운 순간은 누구나 경험하게 됩니다. 학업마인드 점프(학관밥 대선생) 모임에서는 개인의 목표를 세우고 이를 도달할 수 있도록 우리가 함께 노력합니다. ',
        trigger: `CCLC-4-${id}-1`
    },{
        id: `CCLC-4-${id}-1`,
        component: (<div>
            <p>대상: 학업유지 및 학점관리에 도움이 필요한 학부생(학사경고 경험자, 직전 2학기 중 평점 2.4 미만이 있는 학생)</p>
            <p>내용: 학관에 모여 식사를 함께하며 학업과 일상생활 관리를 향상할 수 있도록 자기관리 전략, 미루기 행동 개선, 학업계획 수립과 모니터링에 대한 교육 및 실습</p>
            <p>진행방식: 학기 중 주 1회 총 12회기</p>
        </div>),
        asMessage: true,
        trigger: `CCLC-4-${id}-2`
    },{
        id: `CCLC-4-${id}-2`,
        message: '신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
        trigger: `CCLC-4-${id}-button`
    },{
        id: `CCLC-4-${id}-button`,
        options: [
            { value: 'apply', label: '신청하기', trigger: `CCLC-4-${id}-apply`},
            { value: 'return', label: '돌아가기', trigger: `ob02-${id}-apply`}
        ]
    },{
        id: `CCLC-4-${id}-apply`,
        component: (<div>
            <p> 본 프로그램에 관심을 가져주셔서 감사합니다. 아쉽게도 지금은 신청을 받고 있지않습니다. </p>
            <p> 학업 마인드 점프 (학관밥 대선생)은  1학기( 2월 말 ~ 3월 초) / 2학기 (8월말 ~ 9월 초)에 모집합니다</p>
        </div>),
        asMessage: true,
        trigger: `end-CCLC-4-${id}-apply`
    },{
        id: `end-CCLC-4-${id}-apply`,
        component: <Return lan="KO" program="CCLC-4" trigger={`ob02-${id}-apply`}/>
    },{
        id: `ob03-intro-${id}`,
        component: (
            <div>
                대인관계 때문에 고민이 많으시죠.
                <br /> 이런 프로그램은 어떠세요?
            </div>
        ),
        asMessage: true,
        trigger: `ob03-msg-${id}`
    },{
        id: `ob03-msg-${id}`,
        component: (<div>
            <p><div className="high-light">심리 검사</div>는 공인된 심리 검사지를 통해 자신을 객관적으로 이해하는 것을 도와줍니다. 심리 검사에는 검사 실시 및 해석이 포함되며, 모두 비대면으로 실시됩니다.</p>
            <p><div className="high-light">개인상담</div>은 보통 1주일에 1번씩 1:1로 이루어지며, 대면 또는 비대면으로 이루어집니다. 당면한 어려움을 깊이있게 다룰 수 있습니다.</p>
            <p><div className="high-light">대인관계향상을 위한 T-talk 집단상담</div> 프로그램은 학기 중 주 1회 2~3시간씩, 총 10회기, 대면 및 비대면으로 진행됩니다.</p>
            <p><div className="high-light">공감의 대화법을 배우는 스친 집단상담</div> 프로그램은 학기 중 주 1회 2시간씩, 총 8회기, 대면으로 진행됩니다</p>
        </div>),
        asMessage: true,
        trigger: `ob03-${id}`
    },{
        id: `ob03-${id}`,
        message: '아래 프로그램 이름을 눌러보세요. 더 자세한 설명과 신청 방법이 안내 됩니다.',
        trigger: `ob03-${id}-apply`
    },{
        id: `ob03-${id}-apply`,
        options: [
            { value: 0, label: '심리검사', trigger: `ob03-test-${id}`},
            { value: 1, label: '개인상담', trigger: `ob03-ind-${id}`},
            { value: 2, label: '대인관계향상 집단상담', trigger: `ob03-CCLC-2-${id}` },
            { value:5, label: '공감의 대화법 스친', trigger: `CCLC-5-${id}` },
            { value: 'return', label: '돌아가기', trigger: `rec-${id}`}
        ]
    },{
        id: `ob03-CCLC-2-${id}`,
        message: '대인관계향상 T-talk 집단상담 프로그램에서는 나 자신, 친구, 가족, 연인 등 주변 사람들과의 관계 속의 내 모습을 돌아보고, 여러 관계 속에서 보여지는 나의 모습과 나만이 아는 진짜 나의 모습의 차이를 이해함으로써 보다 자연스러운 \'자기\'를 찾아가는 경험을 제공합니다.',
        trigger: `ob03-CCLC-2-${id}-1`
    },{
        id: `ob03-CCLC-2-${id}-1`,
        component: (<div>
            <p>대상: 관계를 형성하고 의사소통하는 방식을 이해하고 효과적인 방법을 연습해보고 싶은 학부 및 대학원생</p>
            <p>내용: 대인관계 패턴 파악 및 효과적인 의사소통 방법에 대한 심리교육 및 실습</p>
            <p>진행방식: 학기 중 주 1회 2~3시간씩, 총 10회기, 대면 또는 비대면</p>
        </div>),
        asMessage: true,
        trigger: `ob03-CCLC-2-${id}-2`,
    },{
        id: `ob03-CCLC-2-${id}-2`,
        message: '신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
        trigger: `ob03-CCLC-2-${id}-button`
    },{
        id: `ob03-CCLC-2-${id}-button`,
        options: [
            { value: 'apply', label: '신청하기', trigger: `ob03-CCLC-2-${id}-apply`},
            { value: 'return', label: '돌아가기', trigger: `ob03-${id}-apply`}
        ]
    },{
        id: `ob03-CCLC-2-${id}-apply`,
        component: (<div>
            <p>본 프로그램에 관심을 가져주셔서 감사합니다. 아쉽게도 지금은 신청을 받고 있지않습니다. </p>
            <p> T-talk 프로그램은 매 학기 진행되며, 학기 초(3월, 6월, 9월, 12월)에 모집하고 있습니다.</p>
        </div>),
        asMessage: true,
        trigger: `end-ob03-CCLC-2-${id}-apply`
    },{
        id: `end-ob03-CCLC-2-${id}-apply`,
        component: <Return lan="KO" program ="ob03-CCLC-2" trigger={`ob03-${id}-apply`}/>
    },{
        id: `CCLC-5-${id}`,
        message: '"똑똑한 당신, 내 친구에게만은 따뜻하고 싶다면?" ',
        trigger: `CCLC-5-${id}-1`
    },{
        id: `CCLC-5-${id}-1`,
        message: '공감의 대화법 스친은 효과적인 의사소통을 배우고 익혀, 주변 친구들의 고민에 공감하고 따뜻하게 다가가 효과적인 해결책을 모색하는 공감의 대화법을 교육합니다.',
        trigger: `CCLC-5-${id}-2`
    },{
        id: `CCLC-5-${id}-2`,
        component: (<div>
            <p>대상: 나와 타인의 마음을 더 잘 이해하고 싶고, 공감의 대화법을 배우고 싶은 학부 및 대학원생</p>
            <p>내용: 나의 마음을 잘 이해하는 방법, 대화 상황에서 잘 듣고 잘 질문하고 잘 말하는 방법에 대한 심리교육 및 조별 실습</p>
            <p>진행방식: 학기 중 주 1회 2시간씩, 총 8회기</p>
        </div>),
        asMessage: true,
        trigger: `CCLC-5-${id}-3`,
    },{
        id: `CCLC-5-${id}-3`,
        message: '신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
        trigger: `CCLC-5-${id}-button`,
    },{
        id: `CCLC-5-${id}-button`,
        options: [
            { value: 'apply', label: '신청하기', trigger: `CCLC-5-${id}-apply`},
            { value: 'return', label: '돌아가기', trigger: `ob03-${id}-apply`}
        ]

    },{
        id: `CCLC-5-${id}-apply`,
        component: (<div>
            <p>본 프로그램에 관심을 가져주셔서 감사합니다. 아쉽게도 지금은 신청을 받고 있지않습니다. </p>
            <p>스친 프로그램은 매 학기 진행되며, 학기 초(3월, 9월)에 모집하고 있습니다. </p>
        </div>),
        asMessage: true,
        trigger: `end-CCLC-5-${id}-apply`,
    },{
        id: `end-CCLC-5-${id}-apply`,
        component: <Return lan="KO" program="CCLC-5" trigger={`ob03-${id}-apply`}/>,
    },{
        id: `ob04-intro-${id}`,
        component: (
            <div>
                요즘, 번아웃인것 같으시다고요?
                <br />이런 프로그램은 어떠세요?
            </div>
        ),
        asMessage: true,
        trigger: `ob04-msg-${id}`
    },{
        id: `ob04-msg-${id}`,
        component: (<div>
            <p><div className="high-light">심리 검사</div>는 공인된 심리 검사지를 통해 자신을 객관적으로 이해하는 것을 도와줍니다. 심리 검사에는 검사 실시 및 해석이 포함되며, 모두 비대면으로 실시됩니다.</p>
            <p><div className="high-light">개인상담</div>은 보통 1주일에 1번씩 1:1로 이루어지며, 대면 또는 비대면으로 이루어집니다. 당면한 어려움을 깊이있게 다룰 수 있습니다.</p>
            <p><div className="high-light">번아웃-프리</div> 프로그램은 마음챙김 기법을 통한 스트레스 완화 및 심신건강 증진을 돕기 위해 주 1회 진행되는 프로그램입니다.</p>
        </div>),
        asMessage: true,
        trigger: `ob04-${id}`
    },{
        id: `ob04-${id}`,
        message: '아래 프로그램 이름을 눌러보세요. 더 자세한 설명과 신청 방법이 안내 됩니다.',
        trigger: `ob04-${id}-apply`
    },{
        id: `ob04-${id}-apply`,
        options: [
            { value: 0, label: '심리검사', trigger: `ob04-test-${id}`},
            { value: 1, label: '개인상담', trigger: `ob04-ind-${id}`},
            { value:3, label: '번아웃-프리', trigger: `CCLC-3-${id}`},
            { value: 'return', label: '돌아가기', trigger: `rec-${id}`}
        ]
    },{
        id: `CCLC-3-${id}`,
        message: '"달려온 당신, 이제는 건강하게 쉬면서 도약을 준비하자!"  ',
        trigger: `CCLC-3-${id}-1`
    },{
        id: `CCLC-3-${id}-1`,
        message: ' 번아웃프리 프로그램은 숨가쁘게 달려온 서울대인들의 심리적/신체적 소진증후군(burn-out syndrome)을 개선하고, 심신건강을 증진할 수 있도록 합니다.',
        trigger: `CCLC-3-${id}-2`
    },{
        id: `CCLC-3-${id}-2`,
        component: (
            <div>
                <p>대상: 정서조절 및 소진 예방이 필요한 학부 및 대학원생</p>
                <p>내용: 마음챙김 기법을 통한 스트레스 완화 및 심신건강 증진</p>
                <p>진행방식: 방학 중 주 1회, 총 8회기(번아웃 기본)/학기 중 주 1회 총 5회기(번아웃 심화)</p>
            </div>
        ),
        asMessage: true,
        trigger: `CCLC-3-${id}-3`
    },{
        id: `CCLC-3-${id}-3`,
        message: '신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
        trigger: `CCLC-3-${id}-button`
    },{
        id: `CCLC-3-${id}-button`,
        options: [
            { value: 'apply', label: '신청하기', trigger: `CCLC-3-${id}-apply`},
            { value: 'return', label: '돌아가기', trigger: `ob04-${id}-apply`}
        ]
    },{
        id: `CCLC-3-${id}-apply`,
        component: (
            <div>
                <p>본 프로그램에 관심을 가져주셔서 감사합니다. 아쉽게도 지금은 신청을 받고 있지않습니다. </p>
                <p>번아웃프리 프로그램은 매 학기(방학 포함) 진행되며, 학기 초(3월, 6월, 9월, 12월)에 모집하고 있습니다.</p>
            </div>
        ),
        asMessage: true,
        trigger: `end-CCLC-3-${id}-apply`
    },{
        id: `end-CCLC-3-${id}-apply`,
        component: <Return lan="KO" program="CCLC-3" trigger={`ob04-${id}-apply`}/>
    },{
        id: `ob05-intro-${id}`,
        component: (
            <div>
                힘든 이유가 명확하기 않거나 한 가지가 아닐 수도 있어요. 
                <br />심리검사와 개인상담이 도움이 될 거에요.
            </div>
        ),
        asMessage: true,
        trigger: `ob05-msg-${id}`
    },{
        id: `ob05-msg-${id}`,
        component: (<div>
            <p><div className="high-light">심리 검사</div>는 공인된 심리 검사지를 통해 자신을 객관적으로 이해하는 것을 도와줍니다. 심리 검사에는 검사 실시 및 해석이 포함되며, 모두 비대면으로 실시됩니다.</p>
            <p><div className="high-light">개인상담</div>은 보통 1주일에 1번씩 1:1로 이루어지며, 대면 또는 비대면으로 이루어집니다. 당면한 어려움을 깊이있게 다룰 수 있습니다.</p>
        </div>),
        asMessage: true,
        trigger: `ob05-${id}`
    },{
        id: `ob05-${id}`,
        message: '아래 프로그램 이름을 눌러보세요. 더 자세한 설명과 신청 방법이 안내 됩니다.',
        trigger: `ob05-${id}-apply`
    },{
        id: `ob05-${id}-apply`,
        options: [
            { value: 0, label: '심리검사', trigger: `ob05-test-${id}`},
            { value: 1, label: '개인상담', trigger: `ob05-ind-${id}`},
            { value: 'return', label: '돌아가기', trigger: `rec-${id}`}
        ]
    },{
        id: `ob06-intro-${id}`,
        component: (
            <div>
                최근에 자살, 자해 충동이 드셨군요. 
                <br />아래에 나오는 질문에 답해주시면 적절한 프로그램으로 연결해드리겠습니다.
            </div>
        ),
        asMessage: true,
        trigger: `ob06-q1-${id}`
    },{
        id: `ob06-q1-${id}`,
        message: '1. 현재 자살, 자해, 타해를 시도할 구체적인 계획이 있으신가요?',
        trigger: `ob06-q1-${id}-ans`
    },{
        id: `ob06-q1-${id}-ans`,
        options: [
            {value: 'yes', label: '네', trigger: 'SNUCALL'},
            {value: 'no', label: '아니요', trigger: `ob06-q2-${id}`},
            {value: 'return', label: '돌아가기', trigger: `rec-${id}`}
        ]
    },{
        id: `ob06-q2-${id}`,
        message: '2. 최근 2주 안에 자살, 자해, 타해를 실제로 시도한 적이 있으신가요?',
        trigger: `ob06-q2-${id}-ans`
    },{
        id: `ob06-q2-${id}-ans`,
        options: [
            {value: 'yes', label: '네', trigger: 'SNUCALL'},
            {value: 'no', label: '아니요', trigger: `ob06-${id}-msg`}
        ]
    },{
        id: `ob06-${id}-msg`,
        message: '그렇군요. 스누콜이나 개인상담 프로그램이 도움을 줄 수 있을 것 같아요.',
        trigger: `ob06-${id}-apply`,
    },
    {
        id: `ob06-${id}-apply`,
        options: [
            { value: 0, label: '스누콜', trigger: 'SNUCALL'},
            { value: 1, label: '개인상담', trigger: `ob06-ind-${id}`},
            { value: 'return', label: '돌아가기', trigger: `rec-${id}`}
        ]
    },
    {
        id: `list-${id}-intro`,
        message: '각 상담센터에서 제공되는 프로그램은 다음과 같습니다. 신청하고 싶은 프로그램을 제공하는 센터를 선택해주세요.',
        trigger: `list-${id}-intro-01`,
    },
    {
        id: `list-${id}-intro-01`,
        component: (
            <div>
                <p> - 대학생활문화원에서 진행되는 프로그램은 개인상담, 심리검사, 집단상담, 번아웃-프리, 학업마인드 점프, 또래상담 스친 등 다양합니다.  </p>
                <p> - 단과대학 상담실에서 진행되는 프로그램은 개인상담과 심리검사가 있습니다.</p>
                <p> - 경력개발센터에서는 진로 검사, 진로 상담, 진로 설계 집단상담 및 진로 설계 프로그램들이 마련되어 있습니다.</p>
                <p> - 교수학습개발센터에서는 학습상담, 소그룹 학습코칭, 학습유형검사, 다양한 주제의 역량강화 워크숍, 글쓰기 튜터링 및 클리닉 프로그램, 온라인 교육 등을 제공하고 있습니다.  </p>
            </div>
        ),
        asMessage: true,
        trigger: `list-${id}`,
    },
    {
        id: `list-${id}`,
        options: deptCenterInfo[`${id}`].center.concat([
            { value: 's01', label: '대학생활문화원', trigger: `list-CCLC-${id}`},
            { value: 's02', label: '교수학습개발센터', trigger: 'CTL'},
            { value: 's03', label: '경력개발센터', trigger: 'career'},
            { value: 's04', label: '관악학생생활관 학생상담센터 관심', trigger: `DORM-${id}`},
            { value: 'return', label: '돌아가기', trigger: `dept-option-${id}`}
        ])
    },{
        id: `list-CCLC-${id}`,
        message: '대학생활문화원에서 제공되는 프로그램은 매우 다양합니다.  프로그램 이름을 선택하면 자세한 설명과 신청 방법이 안내됩니다.',
        trigger: `list-CCLC-${id}-option`
    },
    {
        id: `list-CCLC-${id}-option`,
        options: [
            { value:0, label: '개인상담', trigger: `CCLC-0-${id}`},
            { value:1, label: '심리검사', trigger: `CCLC-1-${id}`},
            { value:2, label: '대인관계향상 집단상담', trigger: `CCLC-2-${id}` },
            { value:3, label: '번아웃-프리', trigger: `CCLC-3-${id}` },
            { value:4, label: '학업마인드 점프', trigger: `CCLC-4-${id}` },
            { value:5, label: '공감의 대화법 스친', trigger: `CCLC-5-${id}` },
            { value: 'return', label: '돌아가기', trigger: `list-${id}`}
        ]
    },
    {
        id: `CCLC-0-${id}`,
        message: '상담은 현재 당면한 심리적 어려움에 효과적으로 대처할 뿐 아니라, 내면의 잠재력을 발견하면서 성장하는 과정입니다. 상담을 통하여 상담자는 심리적 고통을 유발하는 행동방식, 사고방식, 감정의 문제들을 다루고 삶에 변화가 일어나도록 돕습니다. 상담내용과 사적 정보는 비밀로 유지됩니다. ',
        trigger: `CCLC-0-${id}-msg`
    },{
        id: `CCLC-0-${id}-msg`,
        message: '신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
        trigger: `CCLC-0-${id}-apply`,
    },{
        id: `CCLC-0-${id}-apply`,
        options: [
            { value: 'apply', label: '신청하기', trigger: `CCLC-0-${id}-apply-link`},
            { value: 'return', label: '돌아가기', trigger: `list-CCLC-${id}-option`}
        ]
    },{
        id: `CCLC-0-${id}-apply-link`,
        message: '아래 [신청하기] 버튼을 눌러서 상담 신청서를 작성해주세요.',
        trigger: `CCLC-0-${id}-apply-link-01`
    },
    {
        id: `CCLC-0-${id}-apply-link-01`,
        component: (
            <div><a className='apply-link' href={link} target='_blank'>[신청하기]</a>
            </div>  
        ),
        asMessage: true,
        trigger: `CCLC-0-${id}-apply-link-02`,
    },{
        id: `CCLC-0-${id}-apply-link-02`,
        component: (
            <div>
                <p> - 신청서를 작성하셨으면 상담 센터에서 방문일자 예약을 위해 1~2일 후 전화를 드립니다. </p>
                <p> - 센터에 방문하면 심리검사를 실시한 후, 상담 신청 이유와 스트레스 요인, 주변 상황 등에 대하여 이야기하는 접수 면접을 진행합니다. (2시간 내외 소요) </p>
            </div>
        ),
        asMessage: true,
        trigger: 'ind-img'
    },
    {
        id: `CCLC-1-${id}`,
        message: '심리검사 종류는 MBTI, MMPI, CST, STRONG, TCI등이 있습니다. 우울하거나 심적으로 힘들다고 느낄 때는 MMPI, TCI를, 자신을 더 깊이있게 이해하고 싶을 때는 MBTI, CST, TCI를, 진로에 대한 고민이 있다면 STRONG, MBTI, CST가 도움이 됩니다.',
        trigger: `CCLC-1-${id}-01`
    },{
        id: `CCLC-1-${id}-01`,
        message: '검사 신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
        trigger: `CCLC-1-${id}-apply`
    },{
        id: `CCLC-1-${id}-apply`,
        options: [
            { value: 'apply', label: '신청하기', trigger: `CCLC-1-${id}-apply-link`},
            { value: 'return', label: '돌아가기', trigger: `list-CCLC-${id}-option`}
        ]
    },{
        id: `CCLC-1-${id}-apply-link`,
        message: '아래 [신청하기] 버튼을 눌러서 상담 신청서를 작성해주세요.',
        trigger: `CCLC-1-${id}-apply-link-01`
    },{
        id: `CCLC-1-${id}-apply-link-01`,
        component: (
            <div><a className='apply-link' href={link} target='_blank'>[신청하기]</a>
            </div>  
        ),
        asMessage: true,
        trigger: `CCLC-1-${id}-apply-link-02`,
    },{
        id: `CCLC-1-${id}-apply-link-02`,
        component: (
            <div>
                <p> - 상담 신청서가 접수되면 신청하신 검사를 실시할 수 있는 링크를 이메일로보내드립니다. </p>
                <p> - 신청하신 모든 검사를 완료하면, 센터에서 연락이 와서 해석 상담(1시간) 예약을 도와드립니다. </p>
            </div>
        ),
        asMessage: true,
        trigger: 'test-img'
    },
    {
        id: `CCLC-2-${id}`,
        message: '대인관계향상 T-talk 집단상담 프로그램에서는 나 자신, 친구, 가족, 연인 등 주변 사람들과의 관계 속의 내 모습을 돌아보고, 여러 관계 속에서 보여지는 나의 모습과 나만이 아는 진짜 나의 모습의 차이를 이해함으로써 보다 자연스러운 \'자기\'를 찾아가는 경험을 제공합니다.',
        trigger: `CCLC-2-${id}-1`
    },{
        id: `CCLC-2-${id}-1`,
        component: (<div>
            <p>대상: 관계를 형성하고 의사소통하는 방식을 이해하고 효과적인 방법을 연습해보고 싶은 학부 및 대학원생</p>
            <p>내용: 대인관계 패턴 파악 및 효과적인 의사소통 방법에 대한 심리교육 및 실습</p>
            <p>진행방식: 학기 중 주 1회 2~3시간씩, 총 10회기, 대면 또는 비대면</p>
        </div>),
        asMessage: true,
        trigger: `CCLC-2-${id}-2`
    },{
        id: `CCLC-2-${id}-2`,
        message: '신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
        trigger: `CCLC-2-${id}-2-button`
    },{
        id: `CCLC-2-${id}-2-button`,
        options: [
            { value: 'apply', label: '신청하기', trigger: `CCLC-2-${id}-apply`},
            { value: 'return', label: '돌아가기', trigger: `list-CCLC-${id}-option`}
        ]
    },{
        id: `CCLC-2-${id}-apply`,
        component: (<div>
            <p>본 프로그램에 관심을 가져주셔서 감사합니다. 아쉽게도 지금은 신청을 받고 있지않습니다. </p>
            <p>T-talk 프로그램은 매 학기 진행되며, 학기 초(3월, 6월, 9월, 12월)에 모집하고 있습니다.</p>
        </div>),
        asMessage: true,
        trigger: `end-CCLC-2-apply-${id}`
    },{
        id: `end-CCLC-2-apply-${id}`,
        component: <Return lan="KO" program="CCLC-2" trigger={`list-CCLC-${id}-option`}/>,
    },{
        id: `CCLC-3-${id}`,
        message: '"달려온 당신, 이제는 건강하게 쉬면서 도약을 준비하자!"  ',
        trigger: `CCLC-3-${id}-1`
    },{
        id: `CCLC-3-${id}-1`,
        message: ' 번아웃프리 프로그램은 숨가쁘게 달려온 서울대인들의 심리적/신체적 소진증후군(burn-out syndrome)을 개선하고, 심신건강을 증진할 수 있도록 합니다.',
        trigger: `CCLC-3-${id}-2`,
    },{
        id: `CCLC-3-${id}-2`,
        component: (
            <div>
                <p>대상: 정서조절 및 소진 예방이 필요한 학부 및 대학원생</p>
                <p>내용: 마음챙김 기법을 통한 스트레스 완화 및 심신건강 증진</p>
                <p>진행방식: 방학 중 주 1회, 총 8회기(번아웃 기본)/학기 중 주 1회 총 5회기(번아웃 심화)</p>
            </div>
        ),
        asMessage: true,
        trigger: `CCLC-3-${id}-3`
    },{
        id: `CCLC-3-${id}-3`,
        message: '신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
        trigger: `CCLC-3-${id}button`
    },{
        id: `CCLC-3-${id}button`,
        options: [
            { value: 'apply', label: '신청하기', trigger: `CCLC-3-apply-${id}`},
            { value: 'return', label: '돌아가기', trigger: `list-CCLC-${id}-option`}
        ]
    },{
        id: `CCLC-3-apply-${id}`,
        component: (
            <div>
                <p>본 프로그램에 관심을 가져주셔서 감사합니다. 아쉽게도 지금은 신청을 받고 있지않습니다. </p>
                <p>번아웃프리 프로그램은 매 학기(방학 포함) 진행되며, 학기 초(3월, 6월, 9월, 12월)에 모집하고 있습니다.</p>
            </div>
        ),
        asMessage: true,
        trigger: `end-CCLC-3-apply-${id}`
    },{
        id: `end-CCLC-3-apply-${id}`,
        component: <Return lan="KO" program="CCLC-3" trigger={`list-CCLC-${id}-option`}/>

    },{
        id: `CCLC-4-${id}`,
        message: '낮은 학점, 학사경고는 여러분이 대학생활에서 겪을 수 있는 어려움 중 하나입니다. 삶에서 어려운 순간은 누구나 경험하게 됩니다. 학업마인드 점프(학관밥 대선생) 모임에서는 개인의 목표를 세우고 이를 도달할 수 있도록 우리가 함께 노력합니다. ',
        trigger: `CCLC-4-${id}-1`
    },{
        id: `CCLC-4-${id}-1`,
        component: (<div>
            <p>대상: 학업유지 및 학점관리에 도움이 필요한 학부생(학사경고 경험자, 직전 2학기 중 평점 2.4 미만이 있는 학생)</p>
            <p>내용: 학관에 모여 식사를 함께하며 학업과 일상생활 관리를 향상할 수 있도록 자기관리 전략, 미루기 행동 개선, 학업계획 수립과 모니터링에 대한 교육 및 실습</p>
            <p>진행방식: 학기 중 주 1회 총 12회기</p>
        </div>),
        asMessage: true,
        trigger: `CCLC-4-${id}-2`,
    },{
        id: `CCLC-4-${id}-2`,
        message: '신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
        trigger: `CCLC-4-${id}button`
    },{
        id: `CCLC-4-${id}button`,
        options: [
            { value: 'apply', label: '신청하기', trigger: `CCLC-4-${id}-apply`},
            { value: 'return', label: '돌아가기', trigger: `list-CCLC-${id}-option`}
        ]
    },{
        id: `CCLC-4-${id}-apply`,
        component: (<div>
            <p> 본 프로그램에 관심을 가져주셔서 감사합니다. 아쉽게도 지금은 신청을 받고 있지않습니다. </p>
            <p> 학업 마인드 점프 (학관밥 대선생)은 1학기( 2월 말 ~ 3월 초) / 2학기 (8월말 ~ 9월 초)에 모집합니다</p>
        </div>),
        asMessage: true,
        trigger: `end-CCLC-4-apply-${id}`
    },{
        id: `end-CCLC-4-apply-${id}`,
        component: <Return lan="KO" program="CCLC-4" trigger={`list-CCLC-${id}-option`}/>,
    },{
        id: `CCLC-5-${id}`,
        message: '"똑똑한 당신, 내 친구에게만은 따뜻하고 싶다면?" ',
        trigger: `CCLC-5-${id}-1`
    },{
        id: `CCLC-5-${id}-1`,
        message: '공감의 대화법 스친은 효과적인 의사소통을 배우고 익혀, 주변 친구들의 고민에 공감하고 따뜻하게 다가가 효과적인 해결책을 모색하는 공감의 대화법을 교육합니다.',
        trigger: `CCLC-5-${id}-2`
    },{
        id: `CCLC-5-${id}-2`,
        component: (<div>
            <p>대상: 나와 타인의 마음을 더 잘 이해하고 싶고, 공감의 대화법을 배우고 싶은 학부 및 대학원생</p>
            <p>내용: 나의 마음을 잘 이해하는 방법, 대화 상황에서 잘 듣고 잘 질문하고 잘 말하는 방법에 대한 심리교육 및 조별 실습</p>
            <p>진행방식: 학기 중 주 1회 2시간씩, 총 8회기</p>
        </div>),
        asMessage: true,
        trigger: `CCLC-5-${id}-3`
    },{
        id: `CCLC-5-${id}-3`,
        message: '신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
        trigger: `CCLC-5-${id}-button`
    },{
        id: `CCLC-5-${id}-button`,
        options: [
            { value: 'apply', label: '신청하기', trigger: `CCLC-5-${id}-apply`},
            { value: 'return', label: '돌아가기', trigger: `list-CCLC-${id}-option`}
        ]

    },{
        id: `CCLC-5-${id}-apply`,
        component: (<div>
            <p>본 프로그램에 관심을 가져주셔서 감사합니다. 아쉽게도 지금은 신청을 받고 있지않습니다. </p>
            <p>스친 프로그램은 매 학기 진행되며, 학기 초(3월, 9월)에 모집하고 있습니다. </p>
        </div>),
        asMessage: true,
        trigger: `end-CCLC-5-apply-${id}`
    },{
        id: `end-CCLC-5-apply-${id}`,
        component: <Return lan="KO" program="CCLC-5" ttrigger={`list-CCLC-${id}-option`}/>,
    },{
        id: `DORM-${id}`,
        message: '현재 관악학생생활관에 거주중이신가요?',
        trigger: `if-DORM-${id}`
    },{
        id: `if-DORM-${id}`,
        options: [
            { value: true, label: '네', trigger: `yes-DORM-${id}`},
            { value: false, label: '아니요', trigger: `no-DORM-${id}`}
        ]
    },{
        id: `yes-DORM-${id}`,
        message: '관심에서 제공되는 프로그램은 다음과 같습니다. 프로그램 이름은 선택하면 자세한 설명과 신청 방법이 안내됩니다.',
        trigger: `c${'DORM'}-01`,
        
    },{
        id: `no-DORM-${id}`,
        message: '관악학생생활관 학생삼단센터 관심에서는 생활관 사생을 대상으로 상담을 제공하고 있습니다. 상담이 필요한 경우, 소속 단과대 상담센터나 대학생활문화원을 이용해주세요',
        trigger: `list-${id}`
    },
    {
        id: `c${id}`,
        message: '단과대학 센터에서 제공되는 프로그램은 다음과 같습니다. 프로그램 이름은 선택하면 자세한 설명과 신청 방법이 안내됩니다.',
        trigger: `c${id}-01`,
    },{
        id: `c${id}-01`,
        component: (<div>
            <p> - 심리 검사는 공인된 심리 검사지를 통해 자신을 객관적으로 이해하는 것을 도와줍니다. 심리 검사에는 검사 실시 및 해석이 포함되며, 모두 비대면으로 실시됩니다.</p>
            <p> - 개인상담은 보통 1주일에 1번씩 1:1로 이루어지며, 대면 또는 비대면으로 이루어집니다. 당면한 어려움을 깊이있게 다룰 수 있습니다. </p>
            </div>),
        trigger: `c${id}-option`,
        asMessage: true
    },
    {
        id: `c${id}-option`,
        options: [
            { value: 'test', label: '심리검사', trigger: `c${id}-test`},
            { value: 'ind', label: '개인상담', trigger: `c${id}-ind`}
        ]
    },
    {
        id: `c${id}-ind`,
        message: '상담은 현재 당면한 심리적 어려움에 효과적으로 대처할 뿐 아니라, 내면의 잠재력을 발견하면서 성장하는 과정입니다. 상담을 통하여 상담자는 심리적 고통을 유발하는 행동방식, 사고방식, 감정의 문제들을 다루고 삶에 변화가 일어나도록 돕습니다. 상담내용과 사적 정보는 비밀로 유지됩니다. ',
        trigger: `c${id}-ind-01`,
    },
    {
        id: `c${id}-ind-01`,
        message: '신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
        trigger: `c${id}-ind-apply`
    },
    {
        id: `c${id}-ind-apply`,
        options: [
            { value: 'apply', label: '신청하기', trigger: `c${id}-ind-apply-link`},
            { value: 'return', label: '돌아가기', trigger: `c${id}-option`}
        ]
    },
    {
        id: `c${id}-ind-apply-link`,
        message: '아래 [신청하기] 버튼을 눌러서 상담 신청서를 작성해주세요.',
        trigger: `c${id}-ind-apply-link-01`
    },
    {
        id: `c${id}-ind-apply-link-01`,
        component: (
            <div><a className='apply-link' href={link} target='_blank'>[신청하기]</a>
            </div>  
        ),
        asMessage: true,
        trigger: `c${id}-ind-apply-link-02`,
        
    },
    {
        id: `c${id}-ind-apply-link-02`,
        component: (
            <div>
                <p> - 신청서를 작성하셨으면 상담 센터에서 방문일자 예약을 위해 1~2일 후 전화를 드립니다. </p>
                <p> - 센터에 방문하면 심리검사를 실시한 후, 상담 신청 이유와 스트레스 요인, 주변 상황 등에 대하여 이야기하는 접수 면접을 진행합니다. (2시간 내외 소요) </p>
            </div>
        ),
        asMessage: true,
        trigger: 'ind-img'
    },
    {
        id: `c${id}-test`,
        message: '심리검사 종류는 기본적으로  MBTI, MMPI, CST, STRONG, TCI 등이 있으며, 단과대 센터 별로 차이는 있습니다. 우울하거나 심적으로 힘들다고 느낄 때는 MMPI, TCI를, 자신을 더 깊이있게 이해하고 싶을 때는 MBTI, CST, TCI를, 진로에 대한 고민이 있다면 STRONG, MBTI, CST가 도움이 됩니다.',
        trigger: `c${id}-test-01`,
    },
    {
        id: `c${id}-test-01`,
        message: '검사 신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
        trigger: `c${id}-test-apply`
    },
    {
        id: `c${id}-test-apply`,
        options: [
            { value: 'apply', label: '신청하기', trigger: `c${id}-test-apply-link`},
            { value: 'return', label: '돌아가기', trigger: `c${id}-option`}
        ]
    },
    {
        id: `c${id}-test-apply-link`,
        message: '아래 [신청하기] 버튼을 눌러서 상담 신청서를 작성해주세요.',
        trigger: `c${id}-test-apply-link-01`

    },{
        id: `c${id}-test-apply-link-01`,
        component: (
            <div><a className='apply-link' href={link} target='_blank'>[신청하기]</a>
            </div>  
        ),
        asMessage: true,
        trigger: `c${id}-test-apply-link-02`,
    },

    {
        id: `c${id}-test-apply-link-02`,
        component: (
            <div>
                <p> - 상담 신청서가 접수되면 신청하신 검사를 실시할 수 있는 링크를 이메일로보내드립니다. </p>
                <p> - 신청하신 모든 검사를 완료하면, 센터에서 연락이 와서 해석 상담(1시간) 예약을 도와드립니다. </p>
            </div>
        ),
        asMessage: true,
        trigger: 'test-img'
    },
])
})

const dorm = (function (id) {
    return (
        [
            {
                id: `c${id}-01`,
                component: (<div>
                    <p> - 심리 검사는 공인된 심리 검사지를 통해 자신을 객관적으로 이해하는 것을 도와줍니다. 심리 검사에는 검사 실시 및 해석이 포함되며, 모두 비대면으로 실시됩니다.</p>
                    <p> - 개인상담은 보통 1주일에 1번씩 1:1로 이루어지며, 대면 또는 비대면으로 이루어집니다. 당면한 어려움을 깊이있게 다룰 수 있습니다. </p>
                    </div>),
                trigger: `c${id}-option`,
                asMessage: true
            },
            {
                id: `c${id}-option`,
                options: [
                    { value: 'test', label: '심리검사', trigger: `c${id}-test`},
                    { value: 'ind', label: '개인상담', trigger: `c${id}-ind`}
                ]
            },
            {
                id: `c${id}-ind`,
                message: '상담은 현재 당면한 심리적 어려움에 효과적으로 대처할 뿐 아니라, 내면의 잠재력을 발견하면서 성장하는 과정입니다. 상담을 통하여 상담자는 심리적 고통을 유발하는 행동방식, 사고방식, 감정의 문제들을 다루고 삶에 변화가 일어나도록 돕습니다. 상담내용과 사적 정보는 비밀로 유지됩니다. ',
                trigger: `c${id}-ind-01`,
            },
            {
                id: `c${id}-ind-01`,
                message: '신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
                trigger: `c${id}-ind-apply`
            },
            {
                id: `c${id}-ind-apply`,
                options: [
                    { value: 'apply', label: '신청하기', trigger: `c${id}-ind-apply-link`},
                    { value: 'return', label: '돌아가기', trigger: `c${id}-option`}
                ]
            },
            {
                id: `c${id}-ind-apply-link`,
                message: '아래 [신청하기] 버튼을 눌러서 상담 신청서를 작성해주세요.',
                trigger: `c${id}-ind-apply-link-01`
            },
            {
                id: `c${id}-ind-apply-link-01`,
                component: (
                    <div><a className='apply-link' href={link} target='_blank'>[신청하기]</a>
                    </div>  
                ),
                asMessage: true,
                trigger: `c${id}-ind-apply-link-02`,
                
            },
            {
                id: `c${id}-ind-apply-link-02`,
                component: (
                    <div>
                        <p> - 신청서를 작성하셨으면 상담 센터에서 방문일자 예약을 위해 1~2일 후 전화를 드립니다. </p>
                        <p> - 센터에 방문하면 심리검사를 실시한 후, 상담 신청 이유와 스트레스 요인, 주변 상황 등에 대하여 이야기하는 접수 면접을 진행합니다. (2시간 내외 소요) </p>
                    </div>
                ),
                asMessage: true,
                trigger: 'ind-img'
            },
            {
                id: `c${id}-test`,
                message: '심리검사 종류는 기본적으로  MBTI, MMPI, CST, STRONG, TCI 등이 있으며, 단과대 센터 별로 차이는 있습니다.우울하거나 심적으로 힘들다고 느낄 때는 MMPI, TCI를, 자신을 더 깊이있게 이해하고 싶을 때는 MBTI, CST, TCI를, 진로에 대한 고민이 있다면 STRONG, MBTI, CST가 도움이 됩니다.',
                trigger: `c${id}-test-01`,
            },
            {
                id: `c${id}-test-01`,
                message: '검사 신청을 원하시면 아래의 “신청하기”를, 다른 프로그램을 보고 싶다면 “돌아가기”를 눌러주세요.',
                trigger: `c${id}-test-apply`
            },
            {
                id: `c${id}-test-apply`,
                options: [
                    { value: 'apply', label: '신청하기', trigger: `c${id}-test-apply-link`},
                    { value: 'return', label: '돌아가기', trigger: `c${id}-option`}
                ]
            },
            {
                id: `c${id}-test-apply-link`,
                message: '아래 [신청하기] 버튼을 눌러서 상담 신청서를 작성해주세요.',
                trigger: `c${id}-test-apply-link-01`
        
            },{
                id: `c${id}-test-apply-link-01`,
                component: (
                    <div><a className='apply-link' href={link} target='_blank'>[신청하기]</a>
                    </div>  
                ),
                asMessage: true,
                trigger: `c${id}-test-apply-link-02`,
            },
        
            {
                id: `c${id}-test-apply-link-02`,
                component: (
                    <div>
                        <p> - 상담 신청서가 접수되면 신청하신 검사를 실시할 수 있는 링크를 이메일로보내드립니다. </p>
                        <p> - 신청하신 모든 검사를 완료하면, 센터에서 연락이 와서 해석 상담(1시간) 예약을 도와드립니다. </p>
                    </div>
                ),
                asMessage: true,
                trigger: 'test-img'
            }

        ]
    )
})('DORM');




console.log(dorm);



const Foreign = [
    {
        id: 'deptEN',
        component: (
        <div>
            <p>English counseling service is available for international students, yet only in the Center for Campus Life & Culture.</p>
            Counseling can take different forms such as individual counseling or group counseling.
        </div>
        ),
        asMessage: true,
        trigger: 'deptEN-intro'
    },{
        id: 'deptEN-intro',
        component: (
        <div>
            - <div className="high-light">Individual counseling</div> entails 1:1 confidential meetings that occur once a week.
            <p> - <div className="high-light">Group counseling</div> involves 4-8 students meeting with 1-2 trained counselor(s) to talk about a variety of issues. Choose the program you are interested in.</p>
        </div>),
        trigger: 'option-en',
        asMessage: true
    },
    {
        id: 'option-en',
        options: [
            { value: 'individual', label: 'Individual Counseling', trigger: 'ind-en'},
            { value: 'group', label: 'Group Counseling', trigger: 'gr-en'},
            { value: 'home', label: 'Return', trigger: 'hello-world'}
        ]
    },
    {
        id: 'ind-en',
        component: (<div>
            Visit our Center located on the 5th floor of the Student Center and a receptionist will help you create your case file.
            <p>Before your visit, send an e-mail to <div className="high-light">snu.ecounseling@gmail.com</div> to make a reservation or for more information.</p>
        </div>),
        asMessage: true,
        trigger: 'end-EN'
    },{
        id: 'gr-en',
        component: (<div>
            "Are you lonely, confused, unsatisfied in your relationship?" A rare opportunity to talk about issues you’ve been keeping to yourself with supportive others. A chance to learn more about yourself by examining your current relationship.
            <p>This program is running every semester. E-mail advertisements are sent out at the beginning of a new semester. See you soon.</p>
            </div>),
        asMessage: true,
        trigger: 'end-EN'
    }
]

const theme = {
    background: '#f5f8fb',
    fontFamily: 'Helvetica Neue',
    headerBgColor: '#0f0f70',
    headerFontColor: '#fff',
    headerFontSize: '15px',
    botBubbleColor: '#e2e2e2',
    botFontColor: '#282828',
    userBubbleColor: '#fff',
    userFontColor: '#4a4a4a',
  };

const ChatBotFinal = props => {
    return(
    <ThemeProvider theme={theme}>
        <ChatBot
        headerTitle ="샤샤"
        hideUserAvatar={false}
        hideBotAvatar={true}
        steps={[].concat(steps, dept.flat(), Foreign, indDept, testDept, dorm)}
        hideSubmitButton={true}
        customDelay={Delay}
        botDelay={Delay}
        userDelay={Delay} 
        hideSubmitButton={true}
    />
    </ThemeProvider>)
}

export default ChatBotFinal;


// WEBPACK FOOTER //
// ./src/components/Chat-final.js